import { IComponent } from "@eventr/common";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { routes } from "routing";
import { useEditSectionContext } from "../../feat/editItinerary/editSectionProvider";
import { useGlobalRouter } from "../../feat/globalRouter/useGlobalRouter";
import { ComponentFinder } from "../componentFinder";
import { useScreenTypeContext } from "../state/screenTypeProvider";

interface IPushPathContainerProps {
  data: any;
  renderOptions: IPushPathContainerOptions;
  parentData?: any;
  past?: boolean;
}
interface IPushPathContainerOptions {
  components: IComponent[];
  direction?: "row" | "column";
  alignItems?: "center" | "flex-start" | "flex-end";
  justifyContent?: "center" | "flex-start" | "flex-end";
  visible?: string[];
  maxWidth?: string;
  width?: string;
  pageId?: string;
}

export const PushPathContainer = ({ data, renderOptions, parentData, past }: IPushPathContainerProps) => {
  const { screenType } = useScreenTypeContext();

  const { section } = useEditSectionContext();
  const { pushPath } = useGlobalRouter();
  const { itemId } = useParams<{
    itemId: string;
  }>();
  const path = () => {
    if (renderOptions.pageId) {
      return routes.edit.sectionItemPageItem.build({
        sectionId: section!.id,
        itemId: itemId!,
        pageId: renderOptions.pageId,
        subItemId: data._id,
      });
    } else {
      return routes.edit.sectionItem.build({ sectionId: section!.id, itemId: data._id });
    }
  };

  if (renderOptions.visible && !renderOptions.visible.includes(screenType)) {
    return null;
  } else {
    return (
      <>
        {data && renderOptions.components && (
          <Stack
            direction={renderOptions.direction ?? "row"}
            onClick={() => {
              pushPath(path());
            }}
            sx={{
              alignItems: renderOptions.alignItems ?? "center",
              justifyContent: renderOptions.justifyContent ?? "flex-start",
              maxWidth: renderOptions.maxWidth ?? undefined,
              width: renderOptions.width ?? undefined
            }}>
            {renderOptions.components.map((c, i) => {
              return (
                <ComponentFinder
                  key={"finder_" + c.componentKey + i}
                  data={data}
                  renderOptions={c}
                  componentKey={c.componentKey}
                  parentData={parentData}
                  isInPast={past}
                />
              );
            })}
          </Stack>
        )}
      </>
    );
  }
};
